var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrujula(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 169,
    height: 187,
    viewBox: "0 0 169 187",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-8 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke: #00272e;\r\n        stroke-width: 5px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #035865;\r\n      }\r\n\r\n      .cls-3, .cls-5 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: #707070;\r\n      }\r\n\r\n      .cls-4, .cls-6 {\r\n        fill: #00272e;\r\n      }\r\n\r\n      .cls-5 {\r\n        font-size: 24px;\r\n        font-family: Nunito-Bold, Nunito;\r\n        font-weight: 700;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-7 {\r\n        stroke: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_640",
    "data-name": "Group 640",
    transform: "translate(-2705.224 -12195.356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638",
    transform: "translate(2710.224 12195.728)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_46",
    "data-name": "Ellipse 46",
    className: "cls-1",
    transform: "translate(0 22.629)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 79.5,
    cy: 79.5,
    r: 79.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 79.5,
    cy: 79.5,
    r: 82
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    className: "cls-2",
    cx: 52,
    cy: 52,
    r: 52,
    transform: "translate(28 49.629)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    className: "cls-3",
    transform: "translate(39 61.629)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 41,
    cy: 40.5,
    rx: 41,
    ry: 40.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 41,
    cy: 40.5,
    rx: 40.5,
    ry: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_637",
    "data-name": "Group 637",
    transform: "translate(58.543 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_47",
    "data-name": "Ellipse 47",
    className: "cls-4",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(0.457 -0.371)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "N",
    className: "cls-5",
    transform: "translate(11.457 27.629)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N"))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2725",
    "data-name": "Path 2725",
    className: "cls-2",
    d: "M2238.822,10447.434l10.59,24.166-10.59,25.97-10.86-24.769Z",
    transform: "translate(-2158.923 -10370.708)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2726",
    "data-name": "Path 2726",
    className: "cls-6",
    d: "M123.777,51.884a1.9,1.9,0,1,1-1.9,1.9,1.907,1.907,0,0,1,1.9-1.9m-6.123,1.9a6.123,6.123,0,1,0,6.123-6.123,6.129,6.129,0,0,0-6.123,6.123m41.168,35.043A49.564,49.564,0,1,1,88.73,18.738a49.564,49.564,0,1,1,70.093,70.093m2.983-73.076A53.782,53.782,0,1,0,85.747,91.814a53.782,53.782,0,0,0,76.059-76.059M125.885,92.692V86.785a2.109,2.109,0,1,0-4.218,0v5.907a39.023,39.023,0,0,1-36.8-36.8h5.907a2.109,2.109,0,0,0,0-4.218H84.867a39.022,39.022,0,0,1,36.8-36.8V20.78a2.109,2.109,0,0,0,4.218,0V14.873a39.023,39.023,0,0,1,36.8,36.8h-5.907a2.109,2.109,0,1,0,0,4.218h5.907a39.022,39.022,0,0,1-36.8,36.8M123.776,10.6a43.184,43.184,0,1,0,43.185,43.183A43.234,43.234,0,0,0,123.776,10.6m0,64.21-8.785-21.027,8.785-21.027,8.785,21.027L124.073,74.1Zm1.946-48.339a2.11,2.11,0,0,0-3.893,0l-11.067,26.49a2.193,2.193,0,0,0-.163.828,2.115,2.115,0,0,0,.163.813l11.067,26.49a2.11,2.11,0,0,0,3.893,0L136.79,54.6a2.19,2.19,0,0,0,.163-.828,2.118,2.118,0,0,0-.163-.813Z",
    transform: "translate(-44.502 48.405)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrujula);
export default __webpack_public_path__ + "static/media/Brujula.c1e5593a7f9166218cf9d4c66aef3e72.svg";
export { ForwardRef as ReactComponent };